import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-entity-item-mobile-skeleton',
    templateUrl: './entity-item-mobile-skeleton.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EntityItemMobileSkeletonComponent {}
